import React, { useMemo, useState } from 'react';
import { IDNameDescriptionDictionary } from '../../models/Site';
import moment from 'moment';
import { SimulatorModel } from '../../models/SimulatorModel';
import { Select } from 'antd';
import { IDNameDescriptionItemSelect } from '../../components/_IDNameDescriptionItemSelect';
import { CustomerCardModel } from '../../models/CustomerCardModel';
import "../ClientsStyle.css"
import MessegePopupClient from '../_MessegePopupClient';

export interface ClientPolicyDetailsHouseProps {
    policyItem: any; // Replace 'any' with the actual type of policy if available
    apartmentCoverType: IDNameDescriptionDictionary;
    coveragePercentageType: IDNameDescriptionDictionary;
    orderPlumberType: IDNameDescriptionDictionary;
    collectionMethodtype: IDNameDescriptionDictionary;
    collectionRouteType: IDNameDescriptionDictionary;
    eventTypes: IDNameDescriptionDictionary;
    customerData: any;
    policyTypes: IDNameDescriptionDictionary;

}

const ClientPolicyDetailsHouse: React.FC<ClientPolicyDetailsHouseProps> = ({
    policyItem,
    apartmentCoverType,
    coveragePercentageType,
    orderPlumberType,
    collectionMethodtype,
    collectionRouteType,
    eventTypes,
    customerData,
    policyTypes
}) => {
    const customerModel: CustomerCardModel = new CustomerCardModel();

    const [policy, setPolicy] = useState<any>(policyItem);
    const [oldPolicy, setOldPolicy] = useState<any>(policyItem);

    const [edit, setEdit] = useState<boolean>(false);
    const [showPopUp, setShowPopUp] = useState<boolean>(false);



    const policyData = useMemo(() => {

        const policy_data: Record<string, any> = {};

        if (policy && (policy.itemType === 'policy' || policy.itemType == undefined)) {
            policy_data['fullName'] = customerData.fullName ? customerData.fullName : '';
            policy_data['eventType'] = policy.policyAdditionDetails && policy.policyAdditionDetails.apartmentPolicyType >= 0 ? policy.policyAdditionDetails.apartmentPolicyType : '';
            policy_data['coverType'] = policy.policyAdditionDetails && policy.policyAdditionDetails.coverType >= 0 ? policy.policyAdditionDetails.coverType : '';
            policy_data['policyNumber'] = policy.policyNumber ? policy.policyNumber : '';
            policy_data['brunchName'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehiclePolicyType == 6 ? "פוליסת חובה" :
                policy.policyAdditionDetails.route && policy.policyAdditionDetails.route.comment ? policy.policyAdditionDetails.route.comment : '';

            policy_data['structure'] = policy.policyAdditionDetails && policy.policyAdditionDetails.structure ? policy.policyAdditionDetails.structure : "";
            policy_data['earthquakeStructure'] = policy.policyAdditionDetails && policy.policyAdditionDetails.earthquakeStructure;
            policy_data['structureSize'] = policy.policyAdditionDetails && policy.policyAdditionDetails.structureSize >= 0 ? policy.policyAdditionDetails.structureSize : "";
            policy_data['content'] = policy.policyAdditionDetails && policy.policyAdditionDetails.content ? policy.policyAdditionDetails.content : "";
            policy_data['earthquakeContent'] = policy.policyAdditionDetails && policy.policyAdditionDetails.earthquakeContent;
            policy_data['jewelry'] = policy.policyAdditionDetails && policy.policyAdditionDetails.jewelry ? policy.policyAdditionDetails.jewelry : "";
            policy_data['coveragePercentageType'] = policy.policyAdditionDetails && policy.policyAdditionDetails.coveragePercentageType >= 0 ? policy.policyAdditionDetails.coveragePercentageType : "";
            policy_data['reviewerName'] = policy.policyAdditionDetails && policy.policyAdditionDetails.reviewerName ? policy.policyAdditionDetails.reviewerName : "";

            policy_data['condominium'] = policy.policyAdditionDetails && policy.policyAdditionDetails.condominium;
            policy_data['floor'] = policy.policyAdditionDetails && policy.policyAdditionDetails.floor ? policy.policyAdditionDetails.floor : "";
            policy_data['numberOfFloors'] = policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfFloors;

            policy_data['lien'] = policy.policyAdditionDetails && policy.policyAdditionDetails.lien;
            policy_data['bankAccountNumber'] = policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountNumber ? policy.policyAdditionDetails.bankAccountNumber : "";
            policy_data['bankNumber'] = policy.policyAdditionDetails && policy.policyAdditionDetails.bankNumber ? policy.policyAdditionDetails.bankNumber : "";
            policy_data['bankBranchNumber'] = policy.policyAdditionDetails && policy.policyAdditionDetails.bankBranchNumber ? policy.policyAdditionDetails.bankBranchNumber : "";

            policy_data['thirdParty'] = policy.policyAdditionDetails && policy.policyAdditionDetails.thirdParty;
            policy_data['employersLiability'] = policy.policyAdditionDetails && policy.policyAdditionDetails.employersLiability;
            policy_data['orderPlumberType'] = policy.policyAdditionDetails && policy.policyAdditionDetails.orderPlumberType ? policy.policyAdditionDetails.orderPlumberType : "";
            policy_data['orderElectricianType'] = policy.policyAdditionDetails && policy.policyAdditionDetails.orderElectricianType;




            policy_data['premia'] = policy.policyAdditionDetails && policy.policyAdditionDetails.premiumSum;
            policy_data['updatedDate'] = moment(customerData.updatedDate).format('DD/MM/YYYY');
            policy_data['numberOfPayments'] = policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfPayments ? policy.policyAdditionDetails.numberOfPayments : "";
            policy_data['agentNumber'] = policy.policyAdditionDetails && policy.policyAdditionDetails.agentNumber ? policy.policyAdditionDetails.agentNumber : "";
            policy_data['eventDate'] = policy.policyAdditionDetails && policy.policyAdditionDetails.eventDate ? moment(policy.policyAdditionDetails.eventDate).format('DD/MM/YYYY') : "";
        }

        console.log('policy_data', policy_data, policy);

        return policy_data;
    }, [policy]);

    const onCustomerChange = (field: string, value: string) => {
        // Handle customer change logic here
        console.log(`Customer field ${field} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            customer: {
                ...prevPolicy.customer,
                [field]: value
            }
        }));

    };



    const onAdditionalDetailsChange = (field: string, value: any) => {
        // Handle additional details change logic here
        console.log(`Additional details field ${field} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            policyAdditionDetails: {
                ...prevPolicy.policyAdditionDetails,
                [field]: field == "apartmentPolicyType" || field == "numberOfFloors" ? Number(value) : value
            }
        }));
    };

    const onPrimaryDetailsChange = (field: string, value: any) => {
        // Handle primary details change logic here
        console.log(`Primary details field ${field} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            [field]: value
        }));
    };

    const getLastCompany = (lastCompanyId: string): string => {
        const insuranceCompanies = localStorage.getItem('insuranceCompanies');
        if (!insuranceCompanies) {
            return 'לא צויין';
        }
        const companies = JSON.parse(insuranceCompanies);
        if (!companies || !Array.isArray(companies) || companies.length === 0) {
            return 'לא צויין';
        }
        const lastCompany = companies.find((company: any) => company.id === lastCompanyId);
        if (!lastCompany) {
            return 'לא צויין';
        }
        if (lastCompany.name && lastCompany.name.length > 0) {
            return lastCompany.name;
        }
        return lastCompanyId ? lastCompanyId : 'לא צויין';
    }

    const onSave = async (e: any) => {
        e.preventDefault(); // Prevent default form submission behavior
        // Handle save logic here
        console.log('Saving policy details:', policy);
        const user = localStorage.getItem('loggedUser');
        if (user) {
            const userData = JSON.parse(user);
            if (userData && userData.id) {
                policy.userId = userData.id; // Assuming createdBy is the user ID
            }
        }

        try {
            setEdit(false); // Disable edit mode after saving
            // You can add your save logic here, such as making an API call to save the updated policy
            let res = await customerModel.policyUpdatePolicy(policy);
            console.log('res', res)
            if (res && res.code == "200") {
                console.log('Policy updated successfully:', res);
                setShowPopUp(true);
                // Optionally, you can update the state or show a success message
            }
        } catch (error: any) {
            console.error('Error saving policy:', error);
            // Optionally, you can show an error message to the user
            alert('שגיאה בעדכון המידע. ' + error.message);
        }
    }

    const onCancel = () => {
        // Handle cancel logic here
        console.log('Canceling changes');
        setPolicy(oldPolicy);
        setEdit(false);
    }

    const getCreatorIfo = (creatorUserId: string) => {
        const users = localStorage.getItem('usersList');
        if (!users) {
            return '';
        }
        const usersList = JSON.parse(users);
        if (!usersList || !Array.isArray(usersList) || usersList.length === 0) {
            return '';
        }
        const creatorUser = usersList.find((user: any) => user.id === creatorUserId);
        if (!creatorUser) {
            return '';
        }
        if (creatorUser.fullName && creatorUser.fullName.length > 0) {
            return creatorUser.fullName;
        }
        return creatorUserId ? creatorUserId : '';
    }

    return (
        <>
            {
                showPopUp &&
                <MessegePopupClient
                    onClose={() => setShowPopUp(false)}
                />
            }
            <div className="details-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '35px' }}>
                <div className="row-title">
                    פרטי הפוליסה
                </div>

                {/* {!edit && (
                    <div className='btn-section-warper'>
                        <button className='btn-style' onClick={() => setEdit(true)}>
                            עריכה
                        </button>
                    </div>
                )}

                {edit && (
                    <div className='btn-section-warper'>
                        <button className='btn-style' onClick={onSave}>
                            שמירה
                        </button>
                        <button className='btn-style-cancel' onClick={onCancel}>
                            ביטול
                        </button>
                    </div>
                )} */}
            </div>
            <div style={{ maxHeight: '350px', overflowY: 'auto', borderBottom: '1px solid #9399b7' }}>
                <div className="details-row white-bg">
                    <div className="row-sub-title">
                        כללי
                    </div>
                    <div className="policy-main-details flex-space-between">
                        <div className="cell">
                            <div className="title">
                                שם מבוטח
                            </div>
                            <div className="description cell-value">
                                {customerData && customerData.fullName ? customerData.fullName : ''}
                            </div>
                        </div>


                        <div className="cell">
                            <div className="title">
                                סוג כיסוי
                            </div>
                            <div className="description cell-value">
                                {/* {policy.policyAdditionDetails && policy.policyAdditionDetails.coverType >= 0 && apartmentCoverType[policy.policyAdditionDetails.coverType] 
                            && apartmentCoverType[policy.policyAdditionDetails.coverType].description ? apartmentCoverType[policy.policyAdditionDetails.coverType].description : ''} */}
                                {/* {apartmentCoverType[policyData['coverType']] && apartmentCoverType[policyData['coverType']].description ? apartmentCoverType[policyData['coverType']].description : ''} */}
                                <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChange}
                                    Id={"coverType"} Options={apartmentCoverType}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.coverType >= 0 ? policy.policyAdditionDetails.coverType : ''}
                                />
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                סוג אירוע
                            </div>
                            <div className="description cell-value">
                                {/* {policy.policyAdditionDetails && policy.policyAdditionDetails.eventType >= 0 && eventTypes[policy.policyAdditionDetails.eventType] 
                            && eventTypes[policy.policyAdditionDetails.eventType].description ? eventTypes[policy.policyAdditionDetails.eventType].description : ''} */}
                                <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChange}
                                    Id={"eventType"} Options={eventTypes}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.eventType >= 0 ? policy.policyAdditionDetails.eventType : ''}
                                />

                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                תאריך אירוע
                            </div>
                            <div className="description cell-value">
                                {policyData['eventDate']}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                מספר פוליסה/תוספת
                            </div>
                            <div className="description cell-value">
                                {policyData['policyNumber']}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                סוג ביטוח
                            </div>
                            <div className="description cell-value">
                                <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChange}
                                    Options={policyTypes}
                                    Id={"apartmentPolicyType"}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.apartmentPolicyType ? policy.policyAdditionDetails.apartmentPolicyType : ""}
                                />
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                שם ענף
                            </div>
                            <div className="description cell-value">
                                {policyData['brunchName']}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="details-row white-bg">
                    <div className="policy-main-details" style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', gap: '100px' }}>
                        <div className="cell">
                            <div className="title">
                                מספר סוכן
                            </div>
                            <div className="description cell-value">
                                {policyData['agentNumber']}
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                מפיץ
                            </div>
                            <div className="description cell-value">
                                {policy.policyAdditionDetails && policy.policyAdditionDetails.distributor ? policy.policyAdditionDetails.distributor : ''}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                חברה קודמת
                            </div>
                            <div className="description cell-value">
                                {getLastCompany(policy.policyAdditionDetails && policy.policyAdditionDetails.lastCompanyId)}

                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                כתובת
                            </div>
                            <div className="description cell-value">
                                <input type="text" value={policy.policyAdditionDetails.address} onChange={(e: any) => onAdditionalDetailsChange("address", e.target.value)} disabled={!edit} style={{ width: 500 }} />
                            </div>
                        </div>
                    </div>
                </div>


                <div className="details-row white-bg">
                    <div className="row-sub-title">
                        פרטי הנכס
                    </div>
                    <div className="policy-main-details flex-space-between">
                        <div className="cell">
                            <div className="title">
                                מבנה
                            </div>
                            <div className="description cell-value">
                                {policyData['structure']}
                                <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.structure} onChange={(e: any) => onAdditionalDetailsChange("structure", e.target.value)} disabled={!edit} />
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                {'ר. אדמה (מבנה)'}
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['earthquakeStructure'] == false ? 'לא' : policyData['earthquakeStructure'] == true ? 'כן' : ''} */}
                                <Select
                                    value={policy.policyAdditionDetails && policy.policyAdditionDetails.earthquakeStructure == false ?
                                        'לא' : policy.policyAdditionDetails && policy.policyAdditionDetails.earthquakeStructure == true ? 'כן' : ''}
                                    onChange={(value: any) => onAdditionalDetailsChange("earthquakeStructure", value === 'כן')}
                                    disabled={!edit}
                                    style={{ width: '100px' }}
                                >
                                    <Select.Option value="לא">לא</Select.Option>
                                    <Select.Option value="כן">כן</Select.Option>
                                </Select>
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                {'מ.ר.'}
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['structureSize']} */}
                                <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.structureSize} onChange={(e: any) => onAdditionalDetailsChange("structureSize", e.target.value)} disabled={!edit} />
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                תכולה
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['content']} */}
                                <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.content} onChange={(e: any) => onAdditionalDetailsChange("content", e.target.value)} disabled={!edit} />
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                {'ר. אדמה (תכולה)'}
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['earthquakeContent'] == false ? 'לא' : policyData['earthquakeContent'] == true ? 'כן' : ''} */}
                                <Select
                                    value={policy.policyAdditionDetails && policy.policyAdditionDetails.earthquakeContent == false ?
                                        'לא' : policy.policyAdditionDetails && policy.policyAdditionDetails.earthquakeContent == true ? 'כן' : ''}
                                    onChange={(value: any) => onAdditionalDetailsChange("earthquakeContent", value === 'כן')}
                                    disabled={!edit}
                                    style={{ width: '100px' }}
                                >
                                    <Select.Option value="לא">לא</Select.Option>
                                    <Select.Option value="כן">כן</Select.Option>
                                </Select>
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                תכשיטים
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['jewelry']} */}
                                <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.jewelry} onChange={(e: any) => onAdditionalDetailsChange("jewelry", e.target.value)} disabled={!edit} />
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                {'% משווי התכולה'}
                            </div>
                            <div className="description cell-value">
                                {/* {coveragePercentageType[policyData['coveragePercentageType']] && coveragePercentageType[policyData['coveragePercentageType']].description ? coveragePercentageType[policyData['coveragePercentageType']].description : ''} */}
                                <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChange}
                                    Id={"coveragePercentageType"} Options={coveragePercentageType}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.coveragePercentageType >= 0 ? policy.policyAdditionDetails.coveragePercentageType : ''}
                                />
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                תאריך סקר
                            </div>
                            <div className="description cell-value">
                                <input type="date" value={policy.policyAdditionDetails && policy.policyAdditionDetails.surveyDate && moment(policy.policyAdditionDetails.surveyDate).format('YYYY-MM-DD') != '0001-01-01'
                                    ? moment(policy.policyAdditionDetails.surveyDate).format('YYYY-MM-DD') : ''} onChange={(e: any) => onAdditionalDetailsChange("surveyDate", e.target.value)} disabled={!edit} />
                                {/* {policyData['surveyDate'] ? moment(policyData['surveyDate']).format('DD/MM/YYYY') : ''} */}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                שם הסוקר
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['reviewerName']} */}
                                <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.reviewerName} onChange={(e: any) => onAdditionalDetailsChange("reviewerName", e.target.value)} disabled={!edit} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="details-row white-bg">
                    <div className="row-sub-title">
                        שיתוף ושיעבוד
                    </div>
                    <div className="policy-main-details" style={{ display: 'flex', gap: '30px' }}>
                        <div style={{ display: 'flex' }}>
                            <div className="cell" style={{ marginLeft: '20px' }}>
                                <div className="title">
                                    בית משותף
                                </div>
                                <div className="description cell-value">
                                    {/* {policyData['condominium'] == false ? 'לא' : policyData['condominium'] == true ? 'כן' : ''} */}
                                    <input type="checkbox" checked={policyData['condominium'] == true} onChange={(e: any) => onAdditionalDetailsChange("condominium", e.target.checked)} disabled={!edit} />
                                </div>
                            </div>


                            {policyData['condominium'] && policyData['condominium'] == true ? (
                                <>
                                    <div className="cell" style={{ marginLeft: '20px' }}>
                                        <div className="title">
                                            קומה
                                        </div>
                                        <div className="description cell-value">
                                            <input type="number" value={policy.policyAdditionDetails && policy.policyAdditionDetails.floor} onChange={(e: any) => onAdditionalDetailsChange("floor", e.target.value)} disabled={!edit} />
                                        </div>
                                    </div>
                                    <div className="cell" style={{ marginLeft: '20px' }}>
                                        <div className="title">
                                            מספק קומות
                                        </div>
                                        <div className="description cell-value">
                                            <div className="description cell-value">
                                                <input type="number" value={policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfFloors} onChange={(e: any) => onAdditionalDetailsChange("numberOfFloors", e.target.value)} disabled={!edit} />
                                            </div>
                                            {/* <Select
                                                value={policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfFloors == false ?
                                                    'לא' : policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfFloors == true ? 'כן' : ''}
                                                onChange={(value: any) => onAdditionalDetailsChange("numberOfFloors", value === 'כן')}
                                                disabled={!edit}
                                                style={{ width: '100px' }}
                                            >
                                                <Select.Option value="לא">לא</Select.Option>
                                                <Select.Option value="כן">כן</Select.Option>
                                            </Select> */}
                                        </div>
                                    </div>
                                </>
                            ) : (<></>)
                            }
                        </div>

                        <div style={{ display: 'flex' }}>
                            <div className="cell" style={{ marginLeft: '20px' }}>
                                <div className="title">
                                    שעבוד
                                </div>
                                <div className="description cell-value">
                                    {/* {policyData['lien'] == false ? 'לא' : policyData['lien'] == true ? 'כן' : ''} */}
                                    <input type="checkbox" checked={policyData['lien'] == true} onChange={(e: any) => onAdditionalDetailsChange("lien", e.target.checked)} disabled={!edit} />
                                </div>
                            </div>

                            {policyData['lien'] == true ? (
                                <>
                                    <div className="cell" style={{ marginLeft: '20px' }}>
                                        <div className="title">
                                            שם בנק
                                        </div>
                                        <div className="description cell-value">
                                            <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.involvedBank} onChange={(e: any) => onAdditionalDetailsChange("involvedBank", e.target.value)} disabled={!edit} />
                                        </div>
                                    </div>
                                    <div className="cell" style={{ marginLeft: '20px' }}>
                                        <div className="title">
                                            מספר סניף
                                        </div>
                                        <div className="description cell-value">
                                            <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.involvedBankBranch} onChange={(e: any) => onAdditionalDetailsChange("involvedBankBranch", e.target.value)} disabled={!edit} />
                                        </div>
                                    </div>
                                    <div className="cell" style={{ marginLeft: '20px' }}>
                                        <div className="title">
                                            כתובת הבנק
                                        </div>
                                        <div className="description cell-value">
                                            <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.involvedAddress} onChange={(e: any) => onAdditionalDetailsChange("involvedAddress", e.target.value)} disabled={!edit} />
                                        </div>
                                    </div>
                                </>
                            ) : (<></>)
                            }
                        </div>
                    </div>
                </div>
                <div className="details-row white-bg">
                    <div className="row-sub-title">
                        הרחבות
                    </div>
                    <div className="policy-main-details" style={{ display: 'flex', gap: '50px' }}>
                        <div className="cell">
                            <div className="title">
                                צד ג
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['thirdParty'] == false ? 'לא' : policyData['thirdParty'] == true ? 'כן' : ''} */}
                                <Select
                                    value={policy.policyAdditionDetails && policy.policyAdditionDetails.thirdParty == false ? 'לא'
                                        : policy.policyAdditionDetails && policy.policyAdditionDetails.thirdParty == true ? 'כן' : ''}
                                    onChange={(value: any) => onAdditionalDetailsChange("thirdParty", value === 'כן')}
                                    disabled={!edit}
                                    style={{ width: '100px' }}
                                >
                                    <Select.Option value="לא">לא</Select.Option>
                                    <Select.Option value="כן">כן</Select.Option>
                                </Select>
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                חבות מעבידים
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['employersLiability'] == false ? 'לא' : policyData['employersLiability'] == true ? 'כן' : ''} */}
                                <Select
                                    value={policy.policyAdditionDetails && policy.policyAdditionDetails.employersLiability == false ? 'לא' :
                                        policy.policyAdditionDetails && policy.policyAdditionDetails.employersLiability == true ? 'כן' : ''}
                                    onChange={(value: any) => onAdditionalDetailsChange("employersLiability", value === 'כן')}
                                    disabled={!edit}
                                    style={{ width: '100px' }}
                                >
                                    <Select.Option value="לא">לא</Select.Option>
                                    <Select.Option value="כן">כן</Select.Option>
                                </Select>
                            </div>
                        </div>

                        <div className="cell">
                            <div className="title">
                                שרברב הסדר
                            </div>
                            <div className="description cell-value">
                                {/* {orderPlumberType[policyData['orderPlumberType']] && orderPlumberType[policyData['orderPlumberType']].description ? orderPlumberType[policyData['orderPlumberType']].description : ''} */}
                                <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChange}
                                    Id={"orderPlumberType"} Options={orderPlumberType}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.orderPlumberType >= 0 ? policy.policyAdditionDetails.orderPlumberType : ''}
                                />
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                תיקון מוצרי חשמל
                            </div>
                            <div className="description cell-value">
                                {/* {policyData['orderElectricianType'] == false ? 'לא' : policyData['orderElectricianType'] == true ? 'כן' : ''} */}
                                <Select
                                    value={policy.policyAdditionDetails && policy.policyAdditionDetails.orderElectricianType == false ? 'לא'
                                        : policy.policyAdditionDetails && policy.policyAdditionDetails.orderElectricianType == true ? 'כן' : ''}
                                    onChange={(value: any) => onAdditionalDetailsChange("orderElectricianType", value === 'כן')}
                                    disabled={!edit}
                                    style={{ width: '100px' }}
                                >
                                    <Select.Option value="לא">לא</Select.Option>
                                    <Select.Option value="כן">כן</Select.Option>
                                </Select>

                            </div>
                        </div>

                    </div>
                </div>




                <div className='white-bg flex-space-between'>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            גביה
                        </div>
                        <div className="policy-main-details flex-space-between">
                            <div className="cell fixed-width">
                                <div className="title">
                                    פרמיה לתשלום
                                </div>
                                <div className="description cell-value">
                                    {policyData['premia']}
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מטבע
                                </div>
                                <div className="description cell-value">
                                    ₪
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    שיטת גביה
                                </div>
                                <div className="description cell-value">
                                    <IDNameDescriptionItemSelect
                                        Disabled={!edit}
                                        OnChange={onAdditionalDetailsChange}
                                        Id={"collectionMethodType"} Options={collectionMethodtype}
                                        Value={policy.policyAdditionDetails && policy.policyAdditionDetails.collectionMethodType >= 0 ? policy.policyAdditionDetails.collectionMethodType : ''}
                                    />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מסלול גביה
                                </div>
                                <div className="description cell-value">
                                    <IDNameDescriptionItemSelect
                                        Disabled={!edit}
                                        OnChange={onAdditionalDetailsChange}
                                        Id={"collectionRouteType"} Options={collectionRouteType}
                                        Value={policy.policyAdditionDetails && policy.policyAdditionDetails.collectionRouteType >= 0 ? policy.policyAdditionDetails.collectionRouteType : ''}
                                    />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    תשלומים
                                </div>
                                <div className="description cell-value">
                                    <input type="number" value={policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfPayments} onChange={(e: any) => onAdditionalDetailsChange("numberOfPayments", e.target.value)} disabled={!edit} />
                                    {/* {policyData['numberOfPayments']} */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            פרטי חשבון
                        </div>
                        <div className="policy-main-details flex-space-between">
                            <div className="cell fixed-width">
                                <div className="title">
                                    מספר חשבון
                                </div>
                                <div className="description cell-value">
                                    <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountNumber} onChange={(e: any) => onAdditionalDetailsChange("bankAccountNumber", e.target.value)} disabled={!edit} />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    בנק
                                </div>
                                <div className="description cell-value">
                                    <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankNumber} onChange={(e: any) => onAdditionalDetailsChange("bankNumber", e.target.value)} disabled={!edit} />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    סניף
                                </div>
                                <div className="description cell-value">
                                    <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankBranchNumber} onChange={(e: any) => onAdditionalDetailsChange("bankBranchNumber", e.target.value)} disabled={!edit} />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    שם בעל החשבון
                                </div>
                                <div className="description cell-value">
                                    <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountOwner} onChange={(e: any) => onAdditionalDetailsChange("bankAccountOwner", e.target.value)} disabled={!edit} />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מספר התחייבות
                                </div>
                                <div className="description cell-value">
                                    <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.commitmentNumber} onChange={(e: any) => onAdditionalDetailsChange("commitmentNumber", e.target.value)} disabled={!edit} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='white-bg flex-space-between'>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            פרטי אשראי
                        </div>
                        <div className="policy-main-details" style={{ display: 'flex', gap: '50px' }}>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מספר כרטיס
                                </div>
                                <div className="description cell-value">
                                    <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.ccNumber}
                                        onChange={(e: any) => onAdditionalDetailsChange("ccNumber", e.target.value)} disabled={!edit} />
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    סוג
                                </div>
                                <div className="description cell-value">

                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    תוקף
                                </div>
                                <div className="description cell-value">

                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    בעל הכרטיס
                                </div>
                                <div className="description cell-value">
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    CVV
                                </div>
                                <div className="description cell-value">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="details-row white-bg">
                    <div className="policy-main-details" style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
                        <div className="cell  fixed-width">
                            <div className="title">
                                הוקם ע"י
                            </div>
                            <div className="description cell-value">
                                {policy && policy.creatorUserId ? getCreatorIfo(policy.creatorUserId) : ''}
                            </div>
                        </div>
                        <div className="cell  fixed-width">
                            <div className="title">
                                עודכן ע"י
                            </div>
                            <div className="description cell-value">
                                {policy && policy.userId ? getCreatorIfo(policy.userId) : ''}
                            </div>
                        </div>
                        <div className="cell  fixed-width">
                            <div className="title">
                                תאריך עדכון
                            </div>
                            <div className="description cell-value">
                                {policyData['updatedDate']}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                הערות
                            </div>
                            <div className="description cell-value">
                                <input style={{ width: 500 }} type="text" value={policy.comments} onChange={(e: any) => onPrimaryDetailsChange("comments", e.target.value)} disabled={!edit} />

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default ClientPolicyDetailsHouse;